import TaskDTO from 'models/dto/tasks/taskDTO';
import { CopilotConversationDTO, PromptResponseCitationDTO } from './copilotConversationDTO';

export class SupplierIncidentFindingDTO {
  date?: string;

  kind?: string;

  title?: string;

  summary?: string;

  citations?: PromptResponseCitationDTO[];

  selected?: boolean;

  alreadyRegisteredTaskId?: number;
}

// The Data of the SupplierIncidents process row (ProcessStateSupplierIncidents, PLAN-073)
export class TenantProcessStateSupplierIncidentsDTO {
  assetId?: number;

  assetName?: string;

  stage?: number;

  findings?: SupplierIncidentFindingDTO[];

  summaryMarkdown?: string;

  eligibleTemplateIds?: number[];

  defaultTemplateId?: number;

  allowedTagIds?: number[];

  incidentTagId?: number;

  ownerId?: string;

  newTasks?: TaskDTO[];

  createdTaskIds?: number[];

  // request only: the stage command, read once (createIncidents from the card, save with the Finish)
  command?: string;

  // request only: the assessment task a start from an assessment carries
  consumerTaskId?: number;

  conversation: CopilotConversationDTO;

  constructor() {
    this.conversation = new CopilotConversationDTO();
  }
}
